import { journalRequest, cdnJournalRequest } from './main';
import { YAHOO_TARGET } from '../constants/yahoo';

/** @methods getDiscoverLayoutID - 取得 Discover Page 不同區塊版位的 ID 以供另支 API getDiscoverLayoutData 取得各區塊資料
 * @returns {Promise} axiosPromise
 */
export const getDiscoverLayoutID = () => journalRequest.get(`discover/layouts`);

/** @methods getDiscoverLayoutIDByCDN - 取得 Discover Page 不同區塊版位的 ID 以供另支 API getDiscoverLayoutData 取得各區塊資料
 * @param {number} deviceNumber (Optional)從 init api 取得的 key:'Target'物件，若其 value 為 1 就是一般的 Funliday 使用者，若為 2 就是 yahoo super APP 的使用者
 * @description 放到 CDN 上加速 API，基本等同 journalRequest API 的 get `discover/layouts` 只是 CDN domain 不一樣，另外不確定未來是否有其他參數需求故獨立為一支 function
 * @returns {Promise} axiosPromise
 */
export const getDiscoverLayoutIDByCDN = (deviceNumber, areaID = 'en') => {
  const apiPath =
    deviceNumber === YAHOO_TARGET
      ? `discover/${areaID}/layouts?from=yahoo`
      : `discover/${areaID}/layouts`;

  return cdnJournalRequest.get(apiPath);
};

/** getDiscoverLayoutData - 取得 Discover Page 不同區塊版位的資料
 * @param {Object} param (Required) 傳入解構的物件參數
 * @param {string} param.areaID (Required)目標地區的 ID
 * @param {string} param.layoutID (Required)目標區塊版位的 ID
 * @param {number} param.offset (Optional)取得的資料要忽略多少筆資料 預設 0 筆
 * @param {number} param.limit (Optional)取得的資料數限制 預設一次最大 20 筆
 * @param {object} param.signal (Optional)透過 signal 可在外部呼叫時終止 AJAX
 * @param {object} param.dataNextToken (Optional)此次呼叫後端回的資料是否是亂數(下次分頁呼叫 API 帶了資料才不會重複)
 * @returns {Promise} axiosPromise
 */
export const getDiscoverLayoutData = ({
  areaID = 'en',
  layoutID,
  offset = 0,
  limit = 20,
  signal,
  category,
  dataNextToken,
  deviceNumber
}) => {
  const headers = {};
  if (signal) headers.cancelToken = signal.token;
  let apiPath = `discover/${areaID}/layouts/${layoutID}?offset=${offset}&limit=${limit}`;
  if (category) apiPath += `&category=${category}`;
  if (dataNextToken) apiPath += `&data_next_token=${dataNextToken}`;
  if (deviceNumber === YAHOO_TARGET) apiPath += `&from=yahoo`;
  return journalRequest.get(apiPath, headers);
};

/** searchDiscover - 取得搜尋 Discover 行程、遊記..等等資料
 * @param {Object} param (Required) 傳入解構的物件參數
 * @param {number} param.searchText (Required)搜尋文字
 * @param {number} param.offset (Optional)取得的資料要忽略多少筆資料 預設 0 筆
 * @param {number} param.limit (Optional)取得的資料數限制 預設一次最大 20 筆
 * @param {number} param.type (Required) a | j | t | to (j: journal, t: trip, a: article, to: topic) 若帶入多個，順序就按照字母順序帶入
 * @returns {Promise} axiosPromise
 */
export const searchDiscover = ({
  searchText,
  offset = 0,
  limit = 20,
  type
}) => {
  const searchURL = `discover/search?q=${encodeURIComponent(
    searchText
  )}&offset=${offset}&limit=${limit}&type=${type}`;
  return journalRequest.get(searchURL);
};

/** getArticlesData - 取得搜尋 articles page 資料
 * @param {string} authorID (Required) 該 articles page 的 author 或 owner 的 userID
 * @param {number} articleID (Required) 該 articles page 文章 ID
 * @param {object} signal (Optional)透過 signal 可在外部呼叫時終止 AJAX
 */
export const getArticlesData = (authorID, articleID, signal) => {
  const headers = {};
  if (signal) headers.cancelToken = signal.token;
  return journalRequest.get(`articles/${authorID}/${articleID}`, headers);
};

export const ARTICLES_RESPONSE = {
  SUCCESS: 1
};

// @deprecated getSystemCount()  merge back into getDiscoverLayoutID()
